import { Fragment } from "react";
import { Typography } from "../Typography";
import { formatNumber } from "../../utils";

interface TableHighlightedValueProps {
    value: number;
    usedValue?: number;
    color?: string;
}

export const TableHighlightedValue = ({ value, usedValue, color }:  TableHighlightedValueProps) => { 
    return (
    <Fragment>
        <Typography variant="body2">
            {formatNumber(value)}
        </Typography>
        {!!usedValue && (
            <Typography 
                variant="body2" 
                fontWeight="bold" 
                marginLeft="5px" 
                color={color}
            >
                (-{Number(usedValue).toLocaleString('pt-BR')})
            </Typography>
        )}
    </Fragment>
)};
